import axios from '@/libs/axios';
import PTC_Pedidos from '@/api/PTC/PTC_Pedidos.client';
import { totalBackordersResponse } from '@/utils/pedidoListingRows';
import { validatePeriod } from '@/views/dashboards/customerDashboardPeriod';

// Independent, count-only requests: never replace the orders screen's store,
// pagination or filters. Existing endpoints enforce the authenticated scope.
export async function countDashboardBackorders({ period, clienteid, portal = false }) {
  const error = validatePeriod(period || {});
  if (error) throw new Error(error);
  let response;
  if (portal) {
    response = await new PTC_Pedidos().retornaPedidos({
      DataEmissaoDe: period.dataInicio,
      DataEmissaoAte: period.dataFim,
      contagemBackorders: true,
    });
  } else {
    if (!clienteid) throw new Error('Cliente não identificado.');
    const result = await axios.get('/dashboard/cliente/pedidos', {
      params: { clienteid, ...period, contagemBackorders: true },
    });
    response = result.data;
  }
  return totalBackordersResponse(response);
}
